import React, { useState } from 'react';
import axios from 'axios';
import { FaPaperclip } from 'react-icons/fa';
import { API_BASE_URL } from '../config/apiConfig';
import { useMessage } from '../contexts/MessageContext';

// Botón (icono de clip) situado arriba a la derecha de la pantalla del concurso.
// Al pulsarlo copia al portapapeles el enlace fijo del overlay del usuario para OBS.
const OverlayLinkButton = () => {
  const { showMessage } = useMessage();
  const [cargando, setCargando] = useState(false);

  const copiarAlPortapapeles = async (texto) => {
    // Camino moderno (requiere contexto seguro: https o localhost)
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(texto);
        return true;
      } catch (_) {
        // caer al fallback
      }
    }
    // Fallback para contextos no seguros / navegadores antiguos
    try {
      const area = document.createElement('textarea');
      area.value = texto;
      area.style.position = 'fixed';
      area.style.top = '-1000px';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.focus();
      area.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(area);
      return ok;
    } catch (_) {
      return false;
    }
  };

  const manejarClick = async (event) => {
    event.stopPropagation(); // evitar que el clic revele respuestas (listener global del quiz)
    if (cargando) return;
    setCargando(true);

    try {
      const respuesta = await axios.get(`${API_BASE_URL}/overlay_url.php`, { withCredentials: true });

      if (!respuesta.data?.success || !respuesta.data?.token) {
        throw new Error(respuesta.data?.message || 'No se pudo obtener el enlace');
      }

      const url = `${window.location.origin}/quiz/obs-view?token=${respuesta.data.token}`;
      const copiado = await copiarAlPortapapeles(url);

      if (copiado) {
        showMessage('Enlace del overlay copiado al portapapeles', 'success');
      } else {
        // Si no se pudo copiar, al menos mostrar la URL para copiarla a mano
        showMessage(`Copia este enlace del overlay: ${url}`, 'info', { duration: 15000 });
      }
    } catch (error) {
      const status = error?.response?.status;
      if (status === 401) {
        showMessage('Inicia sesión para obtener tu enlace de overlay', 'error');
      } else {
        showMessage('No se pudo obtener el enlace del overlay', 'error');
      }
    } finally {
      setCargando(false);
    }
  };

  return (
    <button
      type="button"
      onClick={manejarClick}
      disabled={cargando}
      title="Copiar enlace del overlay para OBS"
      aria-label="Copiar enlace del overlay para OBS"
      className="hidden lg:inline-flex items-center justify-center absolute top-3 right-3 z-30 p-2.5 rounded-full bg-slate-800/70 hover:bg-slate-700 text-white shadow-lg backdrop-blur transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <FaPaperclip className="w-5 h-5" />
    </button>
  );
};

export default OverlayLinkButton;
